import { z } from "zod";

export function normalizeEnvString(value: unknown) {
  if (typeof value !== "string") {
    return value;
  }

  const trimmed = value.trim();
  if (
    trimmed.length >= 2 &&
    ((trimmed.startsWith('"') && trimmed.endsWith('"')) ||
      (trimmed.startsWith("'") && trimmed.endsWith("'")) ||
      (trimmed.startsWith("`") && trimmed.endsWith("`")))
  ) {
    return trimmed.slice(1, -1);
  }

  return trimmed;
}

/**
 * Normalize, then treat an empty string as absent.
 *
 * A blank env row must read as `undefined` rather than `""`, or `.optional()`
 * never fires and consumers see a falsy string where they expect nothing. One
 * preprocessor so every optional key agrees on that.
 */
export function emptyToUndefined(value: unknown) {
  const normalized = normalizeEnvString(value);
  return typeof normalized === "string" && normalized.length === 0
    ? undefined
    : normalized;
}

export const requiredUrl = z.preprocess(normalizeEnvString, z.url());

export const optionalUrl = z.preprocess(emptyToUndefined, z.url().optional());

export const optionalSecret = z.preprocess(
  emptyToUndefined,
  z.string().min(1).optional(),
);

export const optionalLongSecret = z.preprocess(
  emptyToUndefined,
  z.string().min(32).optional(),
);
